// extracted by mini-css-extract-plugin
module.exports = {"wrapper-link":"_1HBZn"};